import { makeStyles } from 'makeStyles';
import {
  BACKGROUND_RED,
  BORDERS_GREY,
  BORDERS_PURPLE,
  DARK_GREEN,
  LIGHT_GREEN,
  LIGHT_RED,
  MAIN_BACKGROUND_FIVE_PERCENT,
  PURPLE_MAIN,
  PURPLE_MAIN_BACKGROUND_FIVE_PERCENT,
  STATUS_BLUE,
  TEXT_GREEN,
  TEXT_MAIN,
  WHITE,
} from 'theme/colors';

export const useStylesCommon = makeStyles<any>()((theme, addedCourt = false) => ({
  courtsCellConfig: {
    height: 192,
    '&.MuiTableCell-root': {
      padding: 0,
    },
    width: '120px!important',
    '& > div': {
      borderRight: BORDERS_GREY,
      boxSizing: 'border-box',
      height: '100%',
    },
    '&:last-of-type': {
      borderRight: 'none',
      boxSizing: 'border-box',
    },
  },
  resourceWrapper: {
    backgroundColor: 'rgba(242, 242, 242, 1)',
    height: '100%',
    padding: theme.spacing(1),
    width: '100%',
  },
  resourceIcon: {
    height: '24px',
    position: 'absolute',
    right: 6,
    '&:hover': {
      backgroundColor: theme.palette.grey[400],
      cursor: 'pointer',
    },
  },
  lightGreenBackground: {
    background: LIGHT_GREEN,
  },
  lightRedBackground: {
    background: LIGHT_RED,
  },
  matchContainer: {
    background: addedCourt ? PURPLE_MAIN_BACKGROUND_FIVE_PERCENT : WHITE,
    border: addedCourt ? BORDERS_PURPLE : BORDERS_GREY,
    borderRadius: '5px',
    padding: '10px',
    position: 'relative',
    width: '178px',
    '&:hover': {
      background: addedCourt ? PURPLE_MAIN_BACKGROUND_FIVE_PERCENT : MAIN_BACKGROUND_FIVE_PERCENT,
      border: addedCourt ? `1px solid ${PURPLE_MAIN}` : `1px solid ${theme.palette.primary.main}`,
      cursor: 'grab',
    },
  },
  eventNameTypography: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 10,
  },
  liveTimeTypography: {
    color: TEXT_GREEN,
    fontSize: 12,
    fontWeight: 600,
    padding: '3px',
    textAlign: 'center',
  },
  addedTypography: {
    color: STATUS_BLUE,
    fontSize: 12,
    fontWeight: 600,
    padding: '3px',
    textAlign: 'center',
  },
  side1Side2Typography: {
    fontSize: 12,
    fontWeight: 500,
    textAlign: 'center',
  },
  tableDragHandleCellWrapper: {
    borderLeft: `3px solid ${theme.palette.grey[100]}`,
    padding: '6px',
  },
  tableDragHandleCell: {
    height: '24px',
    marginTop: '4px',
    width: '100%',
    '&:hover': {
      cursor: 'grab',
    },
  },
  tableDragHandleCellAssigned: {
    color: 'grey',
  },
  courtsTableConfig: {
    borderRadius: 0,
    borderTop: BORDERS_GREY,
    borderLeft: BORDERS_GREY,
    boxShadow: 'none',
    '& > div': {
      marginTop: 0,
      minWidth: 200,
    },
  },
  courtTitleWrapper: {
    padding: '7px',
    width: '100%',
    '& h1': {
      overflow: 'hidden',
      maxWidth: '180px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  courtTitle: {
    fontSize: 13,
  },
  courtSubtitle: {
    fontSize: 12,
  },
  firstColumn: {
    height: '100%',
    width: '100%',
  },
  firstColumnText: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'center',
  },
  firstColumnSubText: {
    fontSize: 12,
    fontWeight: 500,
    textAlign: 'center',
  },
  paper: {
    maxWidth: 'fit-content',
    padding: 0,
  },
  paperHeaderContainer: {
    padding: theme.spacing(2),
  },
  paperHeaderArrowsLeftRight: {
    border: BORDERS_GREY,
    borderRadius: '3px',
    height: '40px',
    width: '44px',
  },
  paperHeaderArrowsLeftRightInner: {
    height: '100%',
  },
  arrows: {
    height: '14px',
    width: '14px',
  },
  viewSelect: {
    '& > div': {
      border: 'none',
    },
  },
  viewSelectContainer: {
    height: '42px',
  },
  cellMenu: {
    padding: '10px',
  },
  courtScheduleAccordion: {
    backgroundColor: TEXT_MAIN,
    maxWidth: 'fit-content',
    '& > div': {
      '& > div': {
        margin: `0!important`,
        '& > h1': {
          color: theme.palette.common.white,
          fontWeight: 900,
          margin: 'auto 10px',
        },
      },
    },
  },
  courtsOnScheduleAccordionTitle: {
    fontSize: 16,
  },
  accordionSummaryIconBackground: {
    '& > svg': {
      verticalAlign: 'middle',
    },
    '&:hover': {
      background: 'rgba(255, 255, 255, .15)',
    },
  },
  checkedFacilitiesCheckbox: {
    alignSelf: 'center',
  },
  checkedFacilitiesContent: {
    overflowX: 'hidden',
    padding: '8px 0px',
  },
  checkedFacilitiesCheckboxInput: {
    paddingLeft: 0,
  },
  checkedFacilitiesWarning: {
    color: BACKGROUND_RED,
    padding: '12px 0',
  },
  checkedFacilitiesWarningHidden: {
    display: 'none',
  },
  courtResourceMargin: {
    marginTop: 10,
  },
  courtEventMargin: {
    marginTop: 5,
  },
  onNowWrapper: {
    width: '100%',
    alignSelf: 'center',
  },
  participantName: {
    fontWeight: 'normal',
    textAlign: 'start',
  },
  sideCell: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '15px',
  },
  sideCellWinner: {
    color: DARK_GREEN,
  },
  sideCellPlayers: {
    display: 'block',
  },
  iconWinner: {
    minWidth: '20px',
  },
  emptyMessage: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#737680',
  },
  player: {
    cursor: 'pointer',

    '& span': {
      color: theme.palette.primary.main,

      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
}));
